export interface PromptDetails {
  fullName: string;
  examinatorId: string;
  groupId: string;
  otherText: string;
  typePromp: 'KGZ' | 'ZE' | 'KK';
  type: 'confirmation' | 'success' | 'error';
}

export enum PromptTextRemovedKGZEnum {
  GetMajorCofirmationText = `Czy na pewno chcesz usunąć funkcję KGZ z:`,
  GetSuccessText_1 = 'Usunięcie funkcji KGZ z:',
  GetSuccessText_2 = 'Usunięcie przypisanej funkcji Koordynatora Krajowego Egzaminatorowi:',
  GetSuccessText_2_Bold = `zakończone sukcesem.`,
  GetErrorText_2_Bold = `nie powiodło się, spróbuj ponownie później.`,
  GetMajorCofirmationTextKK = `Czy na pewno chcesz usunąć przypisaną funkcję Koordynatora Krajowego Egzaminatorowi:`,
  GetMajorCofirmationTextZe = 'Czy na pewno chcesz usunąć Egzaminatora:',
  GetSuccessText_Bold_Ze = `zakończone sukcesem.`,
  GetErrorText_Bold_Ze = `nie powiodło się, spróbuj ponownie później.`,
  GetErrorText_Ze = 'nie powiodło się, spróbuj ponownie później.',
  GetTextZeStep2 = 'Usunięcie z Zespołu Egzaminatorów',
}
